import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-documents',
  templateUrl: './documents.component.html',
  styleUrls: ['./documents.component.scss']
})
export class DocumentsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  Scroll1() {
    document.getElementById("Introduction").scrollIntoView();
  }
  Scroll2() {
    document.getElementById("Whatincluded").scrollIntoView();
  }
  Scroll3() {
    document.getElementById("Gettingstarted").scrollIntoView();
  }
  Scroll4() {
    document.getElementById("Gulpfiles").scrollIntoView();
  }
  Scroll5() {
    document.getElementById("Gruntfile").scrollIntoView();
  }
  Scroll6() {
    document.getElementById("MainContent").scrollIntoView();
  }
  Scroll7() {
    document.getElementById("ProjectComponents").scrollIntoView();
  }
  Scroll8() {
    document.getElementById("Chatbody").scrollIntoView();
  }
  Scroll9() {
    document.getElementById("Credits").scrollIntoView();
  }
  Scroll10() {
    document.getElementById("CustomerSupport").scrollIntoView();
  }

  Scroll11() {
    document.getElementById("ChangeLog").scrollIntoView();
  }

}
